export const fieldValidation = {
  required: '{{fieldName}} 是必须的',
  pattern: '{{fieldName}} is invalid',
  maxLength: '{{fieldName}} 字数上限为 {{value}}',
};
